import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import { View, TouchableOpacity } from "react-native";
import haptics from "app/utils/haptics";
// import { StyleContext } from "app/contexts/Style";

const DOUBLE_PRESS_THRESHOLD = 200;

export default class CustomTouchableOpacity extends React.Component {
  // static contextType = StyleContext;

  constructor(props) {
    super(props);
    let defaultHaptics = "light";
    // let hapticFeedback = props.haptics == true ? defaultHaptics : props.haptics;
    let hapticFeedback =
      props.haptics == false
        ? null
        : props.haptics == true || props.haptics == undefined
        ? defaultHaptics
        : props.haptics;

    let safeStyle = {};
    let style = props.style;
    if (Array.isArray(style)) {
      style = style.filter((s) => typeof s == "object");
      safeStyle = Object.assign({}, ...style);
    } else if (typeof style == "object") {
      safeStyle = style;
    }

    this.state = {
      hapticFeedback,
      mouseDownAt: null,
      mouseUpAt: null,
      mouseDownEvent: null,
      mouseUpEvent: null,
      safeStyle,
    };
    this.lastPressAt = null;
    this.mouseDownAt = null;
    this.mouseUpAt = null;
    this.mouseDownEvent = null;
    this.mouseUpEvent = null;
  }

  componentWillUnmount() {
    if (this.longPressListener) clearTimeout(this.longPressListener);
  }

  render() {
    let {
      onPress,
      onLongPress,
      onResponderGrant,
      onResponderRelease,
      onPressIn,
      onPressOut,
      onDoublePress,
      innerRef,
      style,
      ...safeProps
    } = this.props;
    let safeStyle = {
      cursor: "pointer",
    };
    if (Array.isArray(style)) {
      style = style.filter((s) => typeof s == "object");
      safeStyle = Object.assign({}, ...style);
    } else if (typeof style == "object") {
      safeStyle = style;
    }
    return (
      <div
        {...safeProps}
        ref={innerRef}
        style={!!safeStyle.flex ? { flex: safeStyle.flex } : {}}
        // style={safeStyle}
        // onPress={ENV.WEB ? undefined : this.handlePress}
        onMouseDown={this.handleMouseDown}
        // onClick={this.handleClick}
        onContextMenu={this.handleClick}
        onMouseUp={this.handleMouseUp}
        onMouseLeave={this.cancelPress}
      >
        <View style={safeStyle}>{this.props.children}</View>
      </div>
    );
  }

  handleClick = (e) => {
    console.log("click", e.button, !!this.props.onRightClick);
    if (e.button == 2 && !!this.props.onRightClick) {
      this.props.onRightClick(e);
      e.preventDefault();
      return;
    }
  };

  handlePress = (e) => {
    let { hapticFeedback } = this.state;
    if (!!hapticFeedback) {
      haptics[hapticFeedback]();
    }
    // alert(hapticFeedback);
    // return;
    this.props.onPress(e);
    if (!!this.props.onDoublePress) {
      let now = new Date().getTime();
      // console.log(now);
      // if (!!lastPressAt) console.log(now - lastPressAt, DOUBLE_PRESS_THRESHOLD);
      if (
        !!this.lastPressAt &&
        now - this.lastPressAt <= DOUBLE_PRESS_THRESHOLD
      ) {
        this.lastPressAt = null;
        this.props.onDoublePress(e);
      } else {
        this.lastPressAt = now;
      }
    }
  };

  handleMouseDown = (e) => {
    if (this.props.onMouseDown) this.props.onMouseDown(e);

    if (this.longPressListener) clearTimeout(this.longPressListener);

    this.mouseDownEvent = e;
    this.mouseDownAt = new Date().getTime();
    this.mouseUpAt = null;

    // this.longPressListener = setTimeout(() => {
    //   if (!!this.mouseDownAt && !this.mouseUpAt) {
    //     this.mouseUpAt = null;
    //     this.mouseDownAt = null;
    //     this.props.onLongPress && this.props.onLongPress(e);
    //   }
    // }, 500);
  };

  handleMouseUp = async (e) => {
    console.log(e.button, e);
    if (e.button == 2 && !!this.props.onRightClick) {
      // this.props.onRightClick(e);
      e.preventDefault();
      return;
    }
    this.mouseUpAt = new Date().getTime();
    if (!!this.mouseDownAt) {
      if (this.mouseUpAt - this.mouseDownAt >= 500) {
        this.props.onLongPress && this.props.onLongPress(e);
      } else {
        // this.props.onPress && this.handlePress(this.mouseDownEvent);
        this.props.onPress && this.handlePress(e);
      }
    }
    this.mouseDownAt = null;
  };

  cancelPress = () => {
    if (this.longPressListener) clearTimeout(this.longPressListener);
    this.mouseDownAt = null;
    this.mouseUpAt = null;
  };
}
